import { Box, Flex, HStack, VStack } from '@chakra-ui/react';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SearchInput } from '@/components/common/SearchInput';
import { TableSortMenu } from '@/components/common/TableSortMenu';
import IndicatorHeader from '@/components/indicators/IndicatorHeader';
import { columnsDefManageYear } from '@/components/indicators/index/IndicatorData';
import IndicatorFilterDrawer from '@/components/indicators/index/IndicatorFilterDrawer';
import ManageCollecteTablePerIndicator from '@/components/indicators/manage-collecte/ManageCollecteTablePerIndicator';

const collecteSearchSchema = z.object({
  page: z.number().catch(1),
  pageSize: z.number().catch(25),
  filter: z.string().catch(''),
  sort: z.string().catch(''),
});

export const Route = createFileRoute('/_layout/$slug/indicators/per-year')({
  component: RouteComponent,
  validateSearch: (search) => collecteSearchSchema.parse(search),
});

function RouteComponent() {
  const { sort, search, filter } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <VStack maxW="100%" maxH="100vh" overflow={'hidden'} flexGrow={1}>
      <IndicatorHeader />
      <Box p={'0rem 1rem'} w={'full'} h={'80%'}>
        <Box p={'3px'} bg={'#F1F7FA'} justifyContent="center" w={'100%'}>
          <Flex bg="#F1F7FA" justifyContent="center">
            <HStack justifyContent="space-between" width="100%" p="1rem 1.5rem" bg="white" wrap="wrap">
              <SearchInput search={search} />
              <Flex gap={4} justifyContent={'flex-end'} flexGrow={1}>
                <Flex gap={4}>
                  <IndicatorFilterDrawer filter={filter} />
                  <TableSortMenu sort={sort} navigate={navigate} columnsDef={columnsDefManageYear} />
                </Flex>
              </Flex>
            </HStack>
          </Flex>
          <ManageCollecteTablePerIndicator />
        </Box>
      </Box>
    </VStack>
  );
}
